import { render, staticRenderFns } from "./attrSort.vue?vue&type=template&id=2bbf230b&"
import script from "./attrSort.vue?vue&type=script&lang=js&"
export * from "./attrSort.vue?vue&type=script&lang=js&"
import style0 from "./attrSort.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "attrSort.vue"
export default component.exports